import {emptyFn} from './BannerCommon';

// Частичная копия с веба. См. apps/projects/ok/interfaces/ok/IOK.ts, Logger
export interface IBannerStatLogger {
    error: (whereHappened: string, message: string) => void;
    errorEx: (exception: Error, applicationPartWhereExcCaught: string, param2: string, customOperation?: string) => void;
    success: (operation: string, ...params: string[]) => void;
    trace: (operation: string, info: string, applicationPartWhereExcCaught: string, errorName: string) => void;
}

let bannerStatLogger: IBannerStatLogger = {
    error: emptyFn,
    errorEx: emptyFn,
    success: emptyFn,
    trace: emptyFn
};

const DEFAULT_ERROR_OPERATION = 'adBannerError';

const bannerStatLoggerProxy: IBannerStatLogger = {
    error(whereHappened: string, message: string) {
        bannerStatLogger.error(whereHappened, message);
    },
    errorEx(exception: Error, applicationPartWhereExcCaught: string, param2: string, customOperation?: string) {
        bannerStatLogger.errorEx(exception, applicationPartWhereExcCaught, param2, customOperation || DEFAULT_ERROR_OPERATION);
    },
    success(operation: string, ...params: string[]) {
        bannerStatLogger.success(operation, ...params);
    },
    trace(operation: string, info: string, applicationPartWhereExcCaught: string, errorName: string) {
        bannerStatLogger.trace(operation, info, applicationPartWhereExcCaught, errorName);
    }
};

export function getErrorOperationWithSuffix(operationSuffix?: number | string | null) {
    return (operationSuffix || operationSuffix === 0)
        ? `${DEFAULT_ERROR_OPERATION}.${operationSuffix}`
        : DEFAULT_ERROR_OPERATION;
}

export function getBannerStatLogger() {
    return bannerStatLoggerProxy;
}

export function setBannerStatLogger(logger: IBannerStatLogger) {
    bannerStatLogger = logger;
}
